import { Star } from "lucide-react";

/**
 * Master v5 Prompt 15 — 1-5 rating control. Ratings are presented
 * BEFORE the written questions per the product rule ("first the
 * rating and after the questions").
 */
export function RatingRow({ label, value, onChange, testId }) {
  return (
    <div className="mb-4" data-testid={testId}>
      <p className="text-sm font-medium text-ink mb-1.5">{label}</p>
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            className="p-1 -m-1"
            data-testid={`${testId}-star-${n}`}
            aria-label={`${n} star${n === 1 ? "" : "s"}`}
          >
            <Star size={26} className={n <= (value || 0) ? "fill-mustard text-mustard-dark" : "text-ink/20"} />
          </button>
        ))}
      </div>
    </div>
  );
}
